<template>
    <div>
        <v-alert
            text
            dense
            color="warning"          
            icon="mdi-alert-outline"   
            class="mb-2" 
        >
            <span class="black--text">
                Os portais descritos abaixos são os que possuem a integração ativa. Para exibir o limite de anúncios é necessário cadastrá-los na tela de "Regra" do portal. Em caso de alguma divergêcia, entre em contato com AYT.  
            </span>
            
        </v-alert>

        <v-container>
            <v-row>
                <v-col cols="12">
                    <v-simple-table
                        class="bordered-table"
                    >
                        <thead>
                            <tr>
                                <th class="font-weight-bold text-h6">Portal</th>
                                <th class="font-weight-bold text-h6">Marcados / Contratados</th>
                            </tr>
                        </thead>

                        <!-- @click="loadPortalRules(portal.id, portal.nome, portal.modelos)"-->

                        <tbody>
                        <tr v-for="(portal, index) in portalsGrouped" :key="index">
                            <td class="text-body-1">{{ portal.nome }}</td>
                            <td class="text-body-1">
                            <div v-if="portal.modelos.length > 0">
                                <span
                                    v-for="(modelo, idx) in ordenarModelos(portal.modelos)"
                                    :key="idx"
                                >
                                    <v-btn
                                        depressed
                                        color="purple_clean"
                                        class="caption font-weight-bold ma-1"
                                        @click="searchProperty(portal.portal_id,modelo.nome)"
                                    >
                                        {{ formatModeloInfo(modelo, portal.pacotes) }}
                                    </v-btn>
                                </span>
                            </div>
                            <div v-else>
                                <em>(nenhum modelo vinculado)</em>
                            </div>
                            </td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {   
    name: "PropertyPortalSummary",

    created(){
        this.portalSummary()
    },

    computed: {
        me () {
            return this.$store.state.auth.me
        },

        portalsGrouped() {
            // Objeto temporário para agrupar todos os itens por portal_id
            const portalItems = {};
            this.items.forEach(item => {
                if (!portalItems[item.portal_item_id]) {
                    portalItems[item.portal_item_id] = [];
                }
                portalItems[item.portal_item_id].push(item);
            });

            // Array final que será retornado
            const result = [];
            const basicModelNames = ['Padrão', 'Simples', 'Anuncio Comum', 'Sem modelo'];

            // Itera sobre cada portal que foi agrupado
            for (const portalId in portalItems) {
                const itemsDoPortal = portalItems[portalId];
                const firstItem = itemsDoPortal[0]; // Usado para pegar dados comuns do portal

                const portalGroup = {
                    portal_id: firstItem.portal_item_id,
                    nome: firstItem.portal_nome,
                    pacotes: {
                        pacote1: firstItem.pacote1,
                        pacote2: firstItem.pacote2,
                        pacote3: firstItem.pacote3,
                        pacote4: firstItem.pacote4,
                        pacote5: firstItem.pacote5,
                    },
                    modelos: []
                };

                // Objeto para agregar todos os modelos básicos deste portal
                const basicModelAggregator = {
                    nome: 'Sem modelo', // Nome padrão
                    total: 0,
                    hasNamedModel: false // Flag para dar preferência a nomes como 'Simples'
                };

                const otherModels = [];

                // Separa os modelos entre "básicos" (para somar) e "outros"
                itemsDoPortal.forEach(item => {
                    if (basicModelNames.includes(item.modelo)) {
                        // Soma o total no agregador
                        basicModelAggregator.total += item.total_imoveis;
                        // Se o modelo tem um nome "real" (não é 'Sem modelo')
                        // e ainda não capturamos um, usamos este nome.
                        if (item.modelo !== 'Sem modelo' && !basicModelAggregator.hasNamedModel) {
                            basicModelAggregator.nome = item.modelo;
                            basicModelAggregator.hasNamedModel = true;
                        }
                    } else {
                        // É um modelo como 'Destaque', 'Premium', etc. Mantém separado.
                        otherModels.push({
                            nome: item.modelo,
                            total: item.total_imoveis
                        });
                    }
                });

                // Adiciona os modelos "outros" ao resultado
                portalGroup.modelos.push(...otherModels);

                // Se houver algum total nos modelos básicos, adiciona o resultado agregado
                if (basicModelAggregator.total > 0) {
                    portalGroup.modelos.push({
                        nome: basicModelAggregator.nome,
                        total: basicModelAggregator.total
                    });
                }
                
                result.push(portalGroup);
            }

            return result;
        }
    },
    
    mounted() {
        window.scrollTo(0, 0);
    },

    data () {
        return {
            items: []
        }
    }, 
    
    methods: {
        async portalSummary() {
            try {
                const response = await this.$store.dispatch('portalSummary');
                this.items = response.data;
            } catch (error) {
                console.error('Erro ao carregar propriedades:', error);
                // Opcional: exibir mensagem ao usuário
                this.$toast.error('Falha ao carregar os dados. Tente novamente.');
            }
        },

         getPacoteKey(modelo) {
            const m = modelo.trim();
            if (['Padrão', 'Simples', 'Anuncio Comum', 'Sem modelo'].includes(m)) {
                return 'pacote1';
            } else if (['Destaque', 'Destaque Home'].includes(m)) {
                return 'pacote2';
            } else if (m === 'Super Destaque') {
                return 'pacote3';
            } else if (['Destaque Regional', 'Destaque Especial', 'Destaque Exclusivo'].includes(m)) {
                return 'pacote4';
            } else if (m === 'Destaque Superior') {
                return 'pacote5';
            } else if (m === 'Destaque Triplo') {
                return 'pacote6';
            }
            return null; // modelo desconhecido
        },

        formatModeloInfo(modeloItem, pacotes) {
            const pacoteKey = this.getPacoteKey(modeloItem.nome);
            const limite = pacoteKey ? pacotes[pacoteKey] : null;
            
            if (limite !== null && limite !== undefined) {
                if(modeloItem.nome != 'Sem modelo'){
                    return `${modeloItem.nome}: ${modeloItem.total} / ${limite}`;
                }else{
                    return `${modeloItem.total} / ${limite}`;
                }
                
            } else {
                if(modeloItem.nome != 'Sem modelo'){
                    return `${modeloItem.nome}: ${modeloItem.total}`;
                }else{
                    return `${modeloItem.total}`;
                }
                
            }
        },

        searchProperty(portal_id, modelo){
            const params = {};
            params.multiple_status = ['Ativo','Desatualizado'];
            params.portal_id = portal_id;
            if(modelo && modelo != 'Sem modelo'){
                params.modelo = modelo
            }

            this.$router.push({
                name: 'admin.properties2.search',
                query: params
            });
        },

        ordenarModelos(modelos) {
            const ordem = [
                'Simples',
                'Anuncio Comum',
                'Padrão',
                'Destaque',
                'Super Destaque',
                'Destaque Especial',
                'Destaque Premium',
                'Destaque Home',
                'Destaque Regional'
            ];
            return [...modelos].sort((a, b) => {
            const iA = ordem.indexOf(a.nome);
            const iB = ordem.indexOf(b.nome);
            if (iA === -1) return 1;
            if (iB === -1) return -1;
                return iA - iB;
            });
        }
    }    
}
</script>

<style scoped>
.bordered-table {
  border-collapse: collapse;
  width: 100%;
}

.bordered-table th,
.bordered-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
}

.bordered-table th {
  background-color: #f5f5f5;
}
</style>